// Resolves the first non-null field from an object based on a list of field names
export const resolveId = (obj, ...fields) => {
  for (const f of fields) {
    if (obj?.[f] != null) return String(obj[f]);
  }
  return null;
};

// Normalizes user objects to a consistent format with _id and name fields
export const mapUser = (user) => {
  const middleName = (user.middle_name ?? "").trim();

  return {
    _id: resolveId(user, "user_id", "_id", "id"),
    name: user?.name || [user.first_name, middleName, user.last_name].filter(Boolean).join(" "),
  };
};

// Unwraps server responses and maps all users from its data
export const mapUsersResponse = (response) => {
  const userList = Array.isArray(response)
    ? response
    : (response?.data ?? response?.users ?? []);
  return userList.map(mapUser);
};